import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

const Banner = () => {
  const data = useStaticQuery(graphql`
    {
      allMasonContentCreative(
        filter: { meta: { contentType: { eq: "banner" } } }
        sort: {fields: updated_time, order: DESC}
        limit: 1
      ) {
        nodes {
          url
          meta {
            position
            url
          }
        }
      }
    }
  `)
  return (
    <div className="banner-wrap full-bleed bg-gray-200 overflow-hidden">
      {data.allMasonContentCreative.nodes.map(banner => (
        <a target="_blank" href={banner.meta.url===null?"/":banner.meta.url}>
          <div className="img-wrap w-full h-full">
            <img
              className="w-full h-full object-cover"
              src={banner.url}
              alt="banner image"
            />
          </div>
        </a>
      ))}
    </div>
  )
}

export default Banner
